// extracted by mini-css-extract-plugin
export var arrow = "_3z-6";
export var changeItem = "_3z-3";
export var changesHeader = "_3z-1";
export var changesList = "_3z-2";
export var container = "_3z-0";
export var pathLabel = "_3z-4";
export var value = "_3z-7";
export var valuesContainer = "_3z-5";